import React from "react";
import { Bar, Doughnut, Line } from "react-chartjs-2";
import "./registerCharts";
import { PALETTE } from "./registerCharts";
import { fmtKop } from "../../utils/format";

const commonOpts = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
};

// Горизонтальный/вертикальный bar по деньгам (копейки)
export function MoneyBar({ labels, values, horizontal = false }) {
  const data = {
    labels,
    datasets: [
      {
        data: values.map((v) => v / 100),
        backgroundColor: labels.map((_, i) => PALETTE[i % PALETTE.length]),
        borderRadius: 6,
      },
    ],
  };
  const options = {
    ...commonOpts,
    indexAxis: horizontal ? "y" : "x",
    plugins: {
      legend: { display: false },
      tooltip: { callbacks: { label: (c) => fmtKop((c.parsed[horizontal ? "x" : "y"] || 0) * 100) } },
    },
    scales: {
      [horizontal ? "x" : "y"]: { ticks: { callback: (v) => fmtKop(v * 100, { short: true }) } },
    },
  };
  return (
    <div style={{ height: 260 }}>
      <Bar data={data} options={options} />
    </div>
  );
}

export function DoughnutChart({ labels, values, money = false }) {
  const data = {
    labels,
    datasets: [
      {
        data: money ? values.map((v) => v / 100) : values,
        backgroundColor: labels.map((_, i) => PALETTE[i % PALETTE.length]),
        borderColor: "#1c2330",
        borderWidth: 2,
      },
    ],
  };
  const options = {
    ...commonOpts,
    cutout: "62%",
    plugins: {
      legend: { display: true, position: "right", labels: { boxWidth: 12, padding: 10 } },
      tooltip: {
        callbacks: {
          label: (c) => (money ? `${c.label}: ${fmtKop((c.parsed || 0) * 100)}` : `${c.label}: ${c.parsed}`),
        },
      },
    },
  };
  return (
    <div style={{ height: 260 }}>
      <Doughnut data={data} options={options} />
    </div>
  );
}

// MRR waterfall: net-new/churn по месяцам
export function MrrWaterfall({ waterfall }) {
  if (!waterfall || waterfall.length === 0)
    return <div style={{ color: "var(--text-mute)", padding: 24 }}>Недостаточно истории для waterfall.</div>;
  const labels = waterfall.map((w) => w.month);
  const data = {
    labels,
    datasets: [
      {
        label: "Прирост / отток",
        data: waterfall.map((w) => w.net_kop / 100),
        backgroundColor: waterfall.map((w) => (w.net_kop >= 0 ? "#3fb950" : "#f85149")),
        borderRadius: 5,
      },
    ],
  };
  const options = {
    ...commonOpts,
    plugins: {
      legend: { display: false },
      tooltip: { callbacks: { label: (c) => fmtKop((c.parsed.y || 0) * 100) } },
    },
    scales: { y: { ticks: { callback: (v) => fmtKop(v * 100, { short: true }) } } },
  };
  return (
    <div style={{ height: 260 }}>
      <Bar data={data} options={options} />
    </div>
  );
}

// Комбо по месяцам для продукта: регистрации (столбцы) + активные и оплатившие (линии)
export function MonthlyCombo({ months }) {
  const data = {
    labels: months.map((m) => m.label),
    datasets: [
      {
        type: "line", label: "Активные",
        data: months.map((m) => m.active),
        borderColor: "#3fb950", backgroundColor: "#3fb950",
        tension: 0.3, pointRadius: 3, order: 0,
      },
      {
        type: "line", label: "Оплатившие",
        data: months.map((m) => m.pays),
        borderColor: "#d29922", backgroundColor: "#d29922",
        tension: 0.3, pointRadius: 3, order: 1,
      },
      {
        type: "bar", label: "Регистрации",
        data: months.map((m) => m.regs),
        backgroundColor: "rgba(57,197,207,0.75)", borderRadius: 5, order: 2,
      },
    ],
  };
  const options = {
    ...commonOpts,
    plugins: {
      legend: { display: true, position: "bottom", labels: { boxWidth: 12, padding: 12 } },
    },
    scales: { y: { beginAtZero: true } },
  };
  return (
    <div style={{ height: 240 }}>
      <Bar data={data} options={options} />
    </div>
  );
}

// Линия по дням (трафик)
export function DayLine({ points, valueKey = "pageviews", label = "Просмотры" }) {
  const labels = points.map((p) => p.day || p.date || "");
  const data = {
    labels,
    datasets: [
      {
        label,
        data: points.map((p) => p[valueKey] ?? 0),
        borderColor: "#4f7cff",
        backgroundColor: "rgba(79,124,255,0.12)",
        fill: true,
        tension: 0.25,
        pointRadius: 0,
      },
    ],
  };
  return (
    <div style={{ height: 240 }}>
      <Line data={data} options={commonOpts} />
    </div>
  );
}
